import styled from 'styled-components';

const PublishedDate = styled.span`
  font-style: italic;
`;

PublishedDate.displayName = 'PublishedDate';

export default PublishedDate;
